import React from 'react';
import useStyles from './Styles';
import { Grid, Tabs, Tab, Icon } from '@material-ui/core';
import sidebarExpand from '../../assets/sidebar-expand.png';
import azState from '../../assets/az_state.png';
import treemap from '../../assets/treemap.png';
import stackedBar from '../../assets/stacked_bar_chart.png';
import sanky from '../../assets/sanky.png';
import ChartDrawer from './ChartDrawer';
import { useSelector } from 'react-redux';
import userActions from './actions';
import appActions from '../app/actions';

const ChartIcon = (props) => {
    const { icon } = props;
    const classes = useStyles();
    return (
        <Icon classes={{ root: classes.chartIconPlaceholder }}>
            <img className={classes.chartIcon} src={icon} width="26" alt="placeholder-icon.png"/>
        </Icon>
    );
};

const ChartTogglebar = () => {
    const classes = useStyles();
    const { chartDrawer } = useSelector((state) => state.app);
    const { setChartDrawerState } = appActions();
    const { chart } = useSelector((state) => state.central_arizona);
    const { setChart } = userActions();

    const onChangeTab = (event, value) => {
        setChart(value);
    };

    return (
        <Grid container item className={classes.chartTogglebar}>
            <Grid item>
                {
                    !chartDrawer ? <img src={sidebarExpand} className={classes.chartToggleIcon} onClick={() => setChartDrawerState()} alt="chart-toggle.png" /> : <Grid className={classes.chartToggleIcon} style={{ marginBottom: 4 }}></Grid>
                }
                <Tabs value={chart} orientation="vertical" className={classes.chartTabs} onChange={onChangeTab}>
                    <Tab value="central_arizona_shortage_impacts" icon={<ChartIcon icon={azState} />} className={classes.chartTab} />
                    <Tab value="allocations" icon={<ChartIcon icon={treemap} />} className={classes.chartTab} />
                    <Tab value="shortage_impacts_by_community" icon={<ChartIcon icon={stackedBar} />} className={classes.chartTab} />
                    <Tab value="shortage_impacts_by_sector" icon={<ChartIcon icon={sanky} />} className={classes.chartTab} />
                </Tabs>
                {
                    chartDrawer ? <ChartDrawer onClose={() => setChartDrawerState()} /> : ''
                }
            </Grid>
        </Grid>
    );
};

export default ChartTogglebar;